/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Component } from 'react';
import { connect } from 'react-redux';
import moment from 'moment';
import Header from './sub_components/main/header'
import Footer from './sub_components/main/footer'
import Currency from './sub_components/currency'
import * as eventService from '../services/eventService'
let openEvents = null;
class SportAnalysis extends Component {
	constructor(props) {
		super(props);
		this.state = {
			uid: "",
			passcode: "",
			sportType: "",
			eventTypes: [],
			casinoData: null,
			sportsET: ["4", "1", "2", "7", "4339", "400"],
			sportSequence: ["4", "1", "2", "7", "400", "4339", "500", "99"],
			eventNameById: { "4": "Cricket", "1": "Soccer", "2": "Tennis", "7": "Horse Racing", "4339": "Greyhound Racing", "500": "Election", "99": "Casino", "400": "Kabaddi" },
			isSportMounted: false,
			eventDetailPart: [],
			event_dictionary: {}
		};
	}

	componentDidMount() {
		this.setState({ isSportMounted: true }, () => {
			this.dataBuilder()
		})
		// setInterval(() => {
		//   this.dataBuilder()
		// }, 5000)
	}

	componentWillUnmount() {
		this.state.isSportMounted = false;
		clearInterval(openEvents)
	}


	async dataBuilder() {
		let self = this;
		openEvents = setInterval(async function allOpenEvents() {
			clearInterval(openEvents)

			eventService.getAdminEventType().then((res) => {
				if (self.state.isSportMounted) {
					if (!!res && !!res.items && res.items.length > 0) {

						let mkts = res.items

						let openMarkets = !!mkts && mkts.filter((mkt) => {
							return mkt.eventTypeName !== "CASINO" && mkt.resultStatus !== "RESULT_DECLARED" && mkt.eventTypeId !== "300" && mkt.eventTypeId !== "999"
						})
						let casinoMarkets = !!mkts && mkts.filter((mkt) => {
							return mkt.eventTypeName === "CASINO" && mkt.resultStatus !== "RESULT_DECLARED"
						})

						if (casinoMarkets.length > 0) {
							let casinoData = self.casinoParser(casinoMarkets)
							self.setState({ casinoData: casinoData })
						}
						let eventGroup = self.arrayGroupBy(openMarkets, "eventId")
						let evtArr = self.getEventList(eventGroup)
						let compGroup = self.arrayGroupBy(evtArr, "competitionName")
						let eventTypeGroup = self.eventTypeGroup(compGroup)
						let sportType = self.state.sportType

						if (!sportType) {
							for (let et of self.state.sportSequence) {
								if (Object.keys(eventTypeGroup).includes(et)) {
									sportType = et;
									break;
								}
							}
						}

						self.setState({ eventTypes: eventTypeGroup, sportType: sportType })

						openEvents = setInterval(allOpenEvents, 5000)

					} else {

						openEvents = setInterval(allOpenEvents, 5000)
					}
				}
			})
		}, 500)
		// let mkts = await eventService.getAdminEventType()
		// mkts = mkts.items
		// let openMarkets = !!mkts && mkts.filter((mkt) => {
		//   return mkt.eventTypeName !== "CASINO" && mkt.resultStatus !== "RESULT_DECLARED"
		// })
		// let casinoMarkets =!!mkts && mkts.filter((mkt) => {
		//   return mkt.eventTypeName === "CASINO" && mkt.resultStatus !== "RESULT_DECLARED"
		// })
		// if (casinoMarkets.length > 0) {
		//   let casinoData = this.casinoParser(casinoMarkets)
		//   this.setState({ casinoData: casinoData })
		// }
		// let eventGroup = this.arrayGroupBy(openMarkets, "eventId")
		// let evtArr = this.getEventList(eventGroup)
		// let compGroup = this.arrayGroupBy(evtArr, "competitionName")
		// let eventTypeGroup = this.eventTypeGroup(compGroup)
		// this.setState({ eventTypes: eventTypeGroup })
	}

	eventTypeGroup(obj) {
		let data = []
		Array.prototype.forEach.call(Object.keys(obj), (comp, i) => {
			let compitition = {
				"name": comp,
				"eventTypeName": obj[comp][0].eventTypeName,
				"eventTypeId": obj[comp][0].eventTypeId,
				"events": obj[comp]
			}
			data.push(compitition)
		})
		let typeData = this.arrayGroupBy(data, "eventTypeId")
		return typeData
	}

	casinoParser(data) {
		let casinoData = data[0]
		let expo = 0
		Array.prototype.forEach.call(data, (mkt) => {
			expo = expo + mkt.exposure
		})
		casinoData.exposure = expo
		return casinoData
	}

	getEventList(eventObj) {
		let events = []
		Array.prototype.forEach.call(Object.keys(eventObj), (evetId, i) => {
			let evtMkts = eventObj[evetId]
			evtMkts[0].markets = this.getMarketDetails(eventObj[evetId]);
			let eventExpo = 0
			let totalAmount = 0
			let maxProfit = 0
			let totalBets = 0
			Array.prototype.forEach.call(evtMkts, (mkt) => {
				eventExpo = eventExpo + mkt.exposure
				totalAmount = totalAmount + mkt.totalAmount
				maxProfit = maxProfit + mkt.maxProfit
				totalBets = totalBets + mkt.orderCount
			})
			evtMkts[0].exposure = eventExpo
			evtMkts[0].totalBets = totalBets
			evtMkts[0].totalAmount = totalAmount
			evtMkts[0].maxProfit = maxProfit

			events.push(evtMkts[0])
		})
		return events
	}

	arrayGroupBy(ary, attr) {
		let group = ary.reduce((r, a) => {
			r[a[attr]] = [...r[a[attr]] || [], a];
			return r;
		}, {});
		return group
	}

	eventCount(et) {
		let eventTypeData = !!this.state.eventTypes && !!this.state.eventTypes[et] ? this.state.eventTypes[et] : {}
		let event_count = 0

		if (eventTypeData.length > 0) {
			for (let competition of eventTypeData) {
				event_count += competition.events.length
			}
		}
		return event_count
	}

	updateTab(et) {
		this.setState({ sportType: et })
	}

	onChange(e) {
		const name = e.target.name;
		const value = e.target.value;
		this.setState({ [name]: value })
	}

	toggleEventDetailsSection(eventId) {
		let eventDetailPart = this.state.eventDetailPart;
		const indx = eventDetailPart.indexOf(eventId);

		if (indx > -1) {
			eventDetailPart.splice(indx, 1);
		}
		else {
			eventDetailPart.push(eventId)
		}
		this.setState({
			eventDetailPart: eventDetailPart
		});
	}

	getMarketDetails(mrkts) {
		let returnMarkets = {};
		let runnerExpo = [];
		let nonFancyRunnerCount = 0;
		const eventTypeId = mrkts[0].eventTypeId;
		for (const mkt of mrkts) {
			let mktObj = returnMarkets[mkt.marketBettingType === "LINE" ? 'Fancy' : mkt.marketName]
			if (!!mktObj) {
				// mktObj[]
				mktObj['Bets'] = mktObj['Bets'] + parseInt(mkt.orderCount);
				mktObj['Exposure'] = mktObj['Exposure'] + parseFloat(mkt.exposure);
				mktObj['Max Profit'] = mktObj['Exposure'] + parseFloat(mkt.maxProfit);
				if (mkt.marketBettingType === "LINE") {
					mktObj['runnerExpo'] = [];
				} else {
					for (let rnr of mktObj['runnerExpo']) {
						let index = -1;
						const mkt_runnersExposure = Object.values(mkt.runnersExposure);
						for (let i = 0; i < mkt_runnersExposure.length; i++) {
							if (rnr.name.trim().toLowerCase() === mkt_runnersExposure[i].name.trim().toLowerCase()) {
								index = i;
								break;
							}
						}
						if (index > - 1) {
							rnr.sharingMe = rnr.sharingMe + parseFloat(mkt_runnersExposure[index].sharingMe)
						}
					}
				}
				returnMarkets[mkt.marketBettingType === "LINE" ? 'Fancy' : mkt.marketName] = mktObj
			} else {
				mktObj = {};
				mktObj['MarketName'] = mkt.marketBettingType === "LINE" ? 'Fancy' : mkt.marketName;
				mktObj['Bets'] = parseInt(mkt.orderCount);
				mktObj['Exposure'] = parseFloat(mkt.exposure);
				mktObj['Max Profit'] = parseFloat(mkt.maxProfit);
				if (mkt.marketBettingType === "LINE") {
					mktObj['runnerExpo'] = [];
					mktObj['BettingType'] = "LINE";
					mktObj['MarketType'] = "LINE";
				} else {
					mktObj['BettingType'] = mkt.marketBettingType;
					mktObj['MarketType'] = mkt.marketType;
					if (runnerExpo.length === 0) {
						runnerExpo = Object.values(mkt.runnersExposure);
					}
					nonFancyRunnerCount = runnerExpo.length;

					let runnerstouse = [];
					for (const rnr of runnerExpo) {
						let index = -1;
						const mkt_runnersExposure = Object.values(mkt.runnersExposure);
						for (let i = 0; i < mkt_runnersExposure.length; i++) {
							if (rnr.name.trim().toLowerCase() === mkt_runnersExposure[i].name.trim().toLowerCase()) {
								index = i;
								break;
							}
						}
						if (index > - 1) {
							let obj = {};
							obj.name = mkt_runnersExposure[index].name
							obj.sharingMe = parseFloat(mkt_runnersExposure[index].sharingMe)
							runnerstouse.push(obj);
						}

					}
					mktObj['runnerExpo'] = runnerstouse;

					// runnerCount = mkt.runnersExposure.length;
				}
				returnMarkets[mkt.marketBettingType === "LINE" ? 'Fancy' : mkt.marketName] = mktObj
			}

		}
		// eventTypeId
		const bettingTypes = {
			"4": [
				{ mt: "MATCH_ODDS", bt: "ODDS" },
				{ mt: "BOOKMAKER", bt: "BOOKMAKER" },
				{ mt: "SPECIAL_MAKER", bt:"BOOKMAKER"},
				{ mt: "TIED_MATCH", bt: "ODDS" },
				{ mt: "COMPLETED_MATCH", bt: "ODDS" },
				{ mt: "TOURNAMENT_WINNER", bt: "ODDS" },
				{ mt: "MINI_BOOKMAKER", bt: "BOOKMAKER" },
				{ mt: "LINE", bt: "LINE" }
			],
			"1": [
				{ mt: "MATCH_ODDS", bt: "ODDS" },
				{ mt: "BOOKMAKER", bt: "BOOKMAKER" },
				{ mt: "SPECIAL_MAKER", bt:"BOOKMAKER"},
				{ mt: "OVER_UNDER_35", bt: "ODDS" },
				{ mt: "OVER_UNDER_25", bt: "ODDS" },
				{ mt: "OVER_UNDER_15", bt: "ODDS" },
				{ mt: "OVER_UNDER_05", bt: "ODDS" },
				{ mt: "TOURNAMENT_WINNER", bt: "ODDS" },
				{ mt: "MINI_BOOKMAKER", bt: "BOOKMAKER" }
			],
			"2": [
				{ mt: "MATCH_ODDS", bt: "ODDS" },
				{ mt: "BOOKMAKER", bt: "BOOKMAKER" },
				{ mt: "SPECIAL_MAKER", bt:"BOOKMAKER"},
				{ mt: "TOURNAMENT_WINNER", bt: "ODDS" },
				{ mt: "MINI_BOOKMAKER", bt: "BOOKMAKER" }
			],
			"400": [
				{ mt: "MATCH_ODDS", bt: "ODDS" },
				{ mt: "BOOKMAKER", bt: "BOOKMAKER" },
				{ mt: "SPECIAL_MAKER", bt:"BOOKMAKER"},
				{ mt: "MINI_BOOKMAKER", bt: "BOOKMAKER" },
				{ mt: "LINE", bt: "LINE" }
			],
			"500": [
				{ mt: "BOOKMAKER", bt: "BOOKMAKER" },
				{ mt: "SPECIAL_MAKER", bt:"BOOKMAKER"},
				{ mt: "LINE", bt: "LINE" }
			]
		}

		returnMarkets = Object.values(returnMarkets);
		let returnMarketsss = [];
		const currentEventMarketsType = bettingTypes[eventTypeId];
		if (!!currentEventMarketsType) {
			for (const cemt of currentEventMarketsType) {
				for (const rtmkt of returnMarkets) {
					if (rtmkt['BettingType'] === cemt.bt && rtmkt['MarketType'] === cemt.mt) {
						returnMarketsss.push(rtmkt);
					}
				}
			}
		} else {
			returnMarketsss = returnMarkets;
		}

		return { returnMarkets: returnMarketsss, runnerExpo: runnerExpo, nonFancyRunnerCount: nonFancyRunnerCount }
	}
	getEventMarketDictionary(event_dict) {
		this.setState({ event_dictionary: event_dict })
	}
	render() {
		return (
			<div className="bethubs">
				<Header history={this.props.history} getEventMarketDictionary={(event_dict) => this.getEventMarketDictionary(event_dict)} />
				<div className="wrapper">
					<div className="container-fluid container-padding-0">
						<div className="row">
							<div className="col-12 col-sm-12 col-md-12 col-lg-12">
								<div className="main-box">
									<h5 className="text-blue">Sport Analysis</h5>
									<div className="row sportanalysis mt-2">
										<div className="col-12 col-sm-12 col-md-12">
											<ul className="nav nav-tabs  tabs mt-2" role="tablist">
												{this.state.sportSequence.map((et, j) => {
													if (!Object.keys(this.state.eventTypes).includes(et)) {
														return null
													}
													return (
														<li className="nav-item">
															<a style={{ cursor: "pointer" }} className={this.state.sportType === et ? "nav-link active" : "nav-link"} data-toggle="tab" onClick={() => { this.updateTab(et) }} role="tab" >{this.state.eventNameById[et]}
																<span className="ml-1 sportcount">{"(" + this.eventCount(et) + ")"}</span> </a>
														</li>
													)
												})}
												{!!this.state.casinoData && this.state.casinoData !== {} && <li className="nav-item">
													<a style={{ cursor: "pointer" }} className={this.state.sportType === "99" ? "nav-link active" : "nav-link"} data-toggle="tab" onClick={() => { this.updateTab("99") }} role="tab" >{this.state.eventNameById["99"]}</a>
												</li>}
											</ul>
											{this.state.sportType === "99" && !!this.state.casinoData && this.state.casinoData !== {} && <div className="marketanalysisbox mb-3">
												<div className="topbox font-16"><b>Casino</b><span className="ml-2 float-right">Exposure : {Math.round(this.state.casinoData.exposure)}</span></div>
											</div>}
											{!!this.state.eventTypes[this.state.sportType] && this.state.eventTypes[this.state.sportType].map((comp, j) => {
												return (
													<div className="padd-10 table-responsive eventmaspage eventcon pb-0 pt-2">
														<h5 className="text-blue"><i className={"fa fa-arrow-right mr-1"} />{comp.name}</h5>
														<table className="table table-bordered font-14 w-100 nowrap mb-0 ">
															<thead>
																<tr className="bg-dark importeve">
																	<td className="event-width40 wi-35"><span className="font-weight-bold text-white">Event Name</span></td>
																	<td className="event-width10 text-right"><span className="font-weight-bold text-white">Total Bets</span></td>
																	<td className="event-width12 text-right"><span className="font-weight-bold text-white">Exposure</span></td>
																	<td className="event-width12 text-right"><span className="font-weight-bold text-white">Total Amount</span></td>
																	<td className="event-width12 text-right"><span className="font-weight-bold text-white">Max Profit</span></td>
																	{this.state.sportsET.includes(this.state.sportType) && <td className="wi-3 text-center"><span className="font-weight-bold text-white"></span></td>}
																</tr>
															</thead>
															<tbody className="bg-white">
																{!!comp.events && comp.events.map((event) => {
																	let marketsDetails = event.markets;//this.getMarketDetails(event.markets)
																	const eventDetail = this.state.event_dictionary[event.eventId]
                                                   					const eventdate = !!eventDetail && !!eventDetail.openDate ? moment(eventDetail.openDate).format('DD MMM YY HH:mm') : '';
																	return (<>
																		<tr>
																			<td><span className="font-weight-bold" title={eventdate}><a href={"/sportanalysis/" + event.eventId} className=" topboxlink">{event.eventName} - {eventdate}</a></span></td>
																			<td className="text-right"><span className="font-weight-bold">{event.totalBets}</span></td>
																			<td className="text-right"><span className="font-weight-bold">{!!event.exposure ? <Currency amount={event.exposure} isOnlyNumber={true} showColor={false} /> : "0"}</span></td>
																			<td className="text-right"><span className="font-weight-bold">{Math.round(event.totalAmount)}</span></td>
																			<td className="text-right"><span className="font-weight-bold">{Math.round(event.maxProfit)}</span></td>
																			{
																				this.state.sportsET.includes(event.eventTypeId) &&
																				<td className="text-center cursor-pointer"><i className={`fa fa-${this.state.eventDetailPart.indexOf(event.eventId) > -1 ? 'minus' : 'plus'}-circle fa-lg primary-bg-color`} onClick={() => { this.toggleEventDetailsSection(event.eventId) }}></i></td>
																			}
																		</tr>
																		{(this.state.sportsET.includes(event.eventTypeId) && this.state.eventDetailPart.indexOf(event.eventId) > -1) &&
																			<tr>
																				<td colspan="6" className='p-0 ml-5'>
																					<table className="table table-bordered font-14 mobile-wv w-75 float-right nowrap mt-0 mb-3">
																						<thead>
																							<tr className="bg-darklight importeve">
																								<td className="text-left"><span className="font-weight-bold text-white">Markets</span></td>
																								<td className="text-right"><span className="font-weight-bold text-white">Bets</span></td>
																								<td className="text-right"><span className="font-weight-bold text-white">Exposure</span></td>
																								<td className="text-right"><span className="font-weight-bold text-white">Max Profit</span></td>
																								{
																									(!!marketsDetails && marketsDetails.runnerExpo.length > 0) && marketsDetails.runnerExpo.map((rnrexp) => {
																										return (
																											<td className="text-right "><span className="font-weight-bold text-white">{rnrexp.name}</span></td>
																										)
																									})
																								}
																							</tr>
																						</thead>
																						<tbody className="bg-white">
																							{
																								(!!marketsDetails && Object.values(marketsDetails.returnMarkets).length > 0) && Object.values(marketsDetails.returnMarkets).map((rtnmkt) => {
																									return (
																										<tr>
																											<td className="text-left font-weight-bold">{rtnmkt['MarketName']}</td>
																											<td className="text-right">{rtnmkt['Bets']}</td>
																											<td className="text-right">{rtnmkt['Exposure'].toFixed(0)}</td>
																											<td className="text-right">{rtnmkt['Max Profit'].toFixed(0)}</td>
																											{
																												(rtnmkt['MarketName'] === 'Fancy' && marketsDetails.nonFancyRunnerCount > 0) ?
																													<td className='' colSpan={marketsDetails.nonFancyRunnerCount}></td>
																													:
																													rtnmkt['runnerExpo'].length > 0 && rtnmkt['runnerExpo'].map((exrn) => {
																														return (
																															<td className={`text-right ${exrn['sharingMe'] < 0 ? 'text-danger' : 'text-success'}`}>{exrn['sharingMe'].toFixed(0)}</td>
																														)
																													})
																											}
																											{/* { marketsDetails.nonFancyRunnerCount > 0 && (rtnmkt['MarketName'] === 'Fancy' ? 
																										<td className='' colSpan={marketsDetails.nonFancyRunnerCount}></td>
																									:
																										rtnmkt['runnerExpo'].length > 0 && rtnmkt['runnerExpo'].map((exrn)=>{
																											return(
																												<td className="text-right">{exrn['sharingMe'].toFixed(2)}</td>
																											)
																										})
																										
																									)

																									} */}

																										</tr>
																									)
																								})
																							}
																							{/* <tr>
																							<td className="text-left">Odds</td>
																							<td>5</td>
																							<td>-5000</td>
																							<td>-5000</td>
																							<td>-5000</td>
																							<td>2548</td>
																							<td>0</td>
																						</tr>
																						<tr>
																							<td className="text-left">BM</td>
																							<td>10</td>
																							<td>4584</td>
																							<td>4584</td>
																							<td>4584</td>
																							<td>-548</td>
																							<td>0</td>
																						</tr>
																						<tr>
																							<td className="text-left">All Fancy</td>
																							<td >10</td>
																							<td >10</td>
																							<td >10</td>
																							<td colspan="3" className='text-center'>4584</td>
																						</tr> */}
																						</tbody>
																					</table>
																				</td>
																			</tr>}
																	</>)
																})}
															</tbody>
														</table>
													</div>
												)
											})}
											{/* {!!this.state.eventTypes && Object.keys(this.state.eventTypes).length > 0 && Object.keys(this.state.eventTypes).map((eventType, i) => {
												let compitition = this.state.eventTypes[eventType]
												return (<>
													<div className="marketanalysisbox mb-2">
														<div className="topbox font-16"><b>{eventType}</b></div>
														{compitition.map((comp, j) => {
															return (<div className="padd-10 table-responsive eventmaspage pb-0 pt-2">
																<h5 className="text-blue"><i className={"fa fa-arrow-right mr-1"} />{comp.name}</h5>
																<table className="table table-bordered font-14 w-100 nowrap mb-0 ">
																	<thead>
																		<tr className="bg-dark importeve">
																			<td className="event-width40"><span className="font-weight-bold text-white">Event Name</span></td>
																			<td className="event-width10 text-right"><span className="font-weight-bold text-white">Total Order</span></td>
																			<td className="event-width12 text-right"><span className="font-weight-bold text-white">Exposure</span></td>
																			<td className="event-width12 text-right"><span className="font-weight-bold text-white">Total Amount</span></td>
																			<td className="event-width12 text-right"><span className="font-weight-bold text-white">Max Profit</span></td>
																		</tr>
																	</thead>
																	<tbody className="bg-white">
																		{!!comp.events && comp.events.map((event) => {
																			return (<>
																				<tr>
																					<td><span className="font-weight-bold"><a href={"/sportanalysis/" + event.eventId} className=" topboxlink">{event.eventName}</a></span></td>
																					<td className="text-right"><span className="font-weight-bold">{event.totalBets}</span></td>
																					<td className="text-right"><span className="font-weight-bold">{!!event.exposure ? <Currency amount={event.exposure} showColor={true} /> : "0"}</span></td>
																					<td className="text-right"><span className="font-weight-bold">{event.totalAmount.toFixed(2)}</span></td>
																					<td className="text-right"><span className="font-weight-bold">{event.maxProfit.toFixed(2)}</span></td>
																				</tr>
																			</>)
																		})}
																	</tbody>
																</table>
															</div>)
														})
														}
													</div>
												</>)
											})
											} */}
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
				<Footer />
			</div>
		)
	}
}
function mapStateToProps(state) {
	return {
	};
}
function mapDispatchToProps(dispatch) {
	return {
	};
}
export default connect(mapStateToProps, mapDispatchToProps)(SportAnalysis);